<div class="el-breadcrumb-wrapper">
    <div class="container">
        <div class="el-breadcrmb-inner">
            <h1>Free Mock Test</h1>
            <ul>
                <li>
                    <a [routerLink]="['/dashboard']" style="color: #e04787;"><i class="fa fa-reply "
                            aria-hidden="true"></i>
                        Back</a>
                </li>
            </ul>
        </div>
    </div>
</div>
<!-- Breadcrumb Start -->


<div class="el-blog-single-wrapper el-blog-medium-wrapper pt-4">
    <form [formGroup]="object" (ngSubmit)="Process()">
        <div class="container">
            <div class="d-flex justify-content-center" *ngIf="PREP_UserInfo?.childId==null">
                <div class="col-md-5 alert">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"
                        style="font-size: 50px;color: #e04787;"></i>
                    <br><br>
                    No child added yet. Kindly add a child to proceed
                    <br><br>
                    <a (click)="Switch_Child()" class="el-btn"> <strong>Add Child</strong></a>
                </div>
            </div>
            <div class="el-inner-blog-box el-blogsingle-comment-box el-blgs-comments-wrapper"
                *ngIf="PREP_UserInfo?.childId!=null">

                <div class="el-blgs-comments ">
                    <div class="col-md-12">
                        <div class="el-blgs-cmts">
                            <div class="row">
                                <div class="col-md-12 d-flex justify-content-between my-2">
                                    <div>
                                        Child Name: <strong>{{PREP_UserInfo?.childName}}</strong><br>
                                        Class: <strong>{{PREP_UserInfo?.className}}</strong>
                                    </div>
                                    <div>
                                        <button type="button" class="el-btn" (click)="Switch_Child()">Switch
                                            Child</button>
                                        <!-- <a class="el-btn" [routerLink]="['/mychild']">Switch Child</a> -->
                                    </div>
                                </div>
                                <div class="col-md-4">

                                    <label>Subject</label>

                                    <select class="" formControlName="eventLetter">
                                        <option [ngValue]="null">-- Select --</option>
                                        <option *ngFor="let _obj of subjectList" [value]="_obj.eventLetter">
                                            {{_obj.subjectName}}</option>
                                    </select>
                                    <div *ngIf="_form.eventLetter.invalid && (_form.eventLetter.dirty || _form.eventLetter.touched)"
                                        class="error">
                                        <div *ngIf="_form.eventLetter.errors?.required"> Subject is required.</div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>

                </div>
                <div class="el-blgs-comments ">

                    <div class="el-blgs-cmts">
                        <div class="row">
                            <b class="pb-3 pt-0"><span class="color-theme">Please note:</span> Each mock test can be
                                attempted only once. Review your
                                preparation carefully
                                before proceeding.</b>
                        </div>
                        <div class="el-blgs-cmt-name">

                            <h5>Disclaimer:</h5>

                        </div>
                        <p class="el-para"><label><input type="checkbox" formControlName="isDisclaimer"> This mock test
                                is intended solely for educational and practice purposes. It is not affiliated with or
                                endorsed by any
                                official examination authority. The content has been created to help students
                                self-assess their preparation and improve
                                their performance. All efforts have been made to ensure the accuracy of the content, but
                                we do not guarantee its
                                completeness or correctness. By using this test, you agree that we are not liable for
                                any outcomes resulting from its
                                use.
                            </label></p>
                        <div *ngIf="_form.isDisclaimer.invalid && (_form.isDisclaimer.dirty || _form.isDisclaimer.touched)"
                            class="error">
                            <div *ngIf="_form.isDisclaimer.errors?.required"> Disclaimer is required.</div>
                        </div>
                        <br><br>
                        <a (click)="Process()" class="el-btn py-4">

                            Proceed
                        </a>
                    </div>
                </div>



                <div class="el-comment-title">
                    <h4 class="el-blog-title">Instruction</h4>
                </div>
                <div class="el-blgs-comments ms-0">
                    <div class="el-blgs-cmts-img">

                        🎯
                    </div>
                    <div class="el-blgs-cmts">
                        <div class="el-blgs-cmt-name">
                            <h5>Why You Should Attempt This Mock Test</h5>

                        </div>
                        <p class="el-para">Taking this mock test is more than just practice — it's a smart step toward
                            success in your actual exam. Here's how it
                            helps:</p>

                    </div>
                </div>
                <div class="el-blgs-comments ms-0">
                    <div class="el-blgs-cmts-img ">
                        🧠
                    </div>
                    <div class="el-blgs-cmts">
                        <div class="el-blgs-cmt-name">
                            <h5>Familiarize Yourself with the Real Exam Format</h5>

                        </div>
                        <p class="el-para">Experience the same structure, question types, and time limits used in the
                            actual
                            test.<br>

                            Reduce uncertainty and eliminate surprises on exam day.</p>

                    </div>
                </div>
                <div class="el-blgs-comments ms-0">
                    <div class="el-blgs-cmts-img">
                        🚀
                    </div>
                    <div class="el-blgs-cmts">
                        <div class="el-blgs-cmt-name">
                            <h5>Boost Your Confidence</h5>

                        </div>
                        <p class="el-para">Build self-assurance by knowing what to expect.<br>

                            Enter the real exam feeling prepared and mentally ready.</p>

                    </div>
                </div>
                <div class="el-blgs-comments">
                    <div class="el-blgs-cmts-img">
                        📊
                    </div>
                    <div class="el-blgs-cmts">
                        <div class="el-blgs-cmt-name">
                            <h5>Identify Strengths and Areas for Improvement</h5>

                        </div>
                        <p class="el-para">Receive instant feedback after the test.<br>

                            Focus your efforts on the topics that need more attention.
                            <br>
                            Track your progress over time.
                        </p>

                    </div>
                </div>

                <div class="el-blgs-comments ">
                    <div class="el-blgs-cmts-img">
                        ⏱️
                    </div>
                    <div class="el-blgs-cmts">
                        <div class="el-blgs-cmt-name">
                            <h5>Enhance Your Time Management Skills</h5>

                        </div>
                        <p class="el-para">Practice completing questions within the given time limit.<br>

                            Learn how to pace yourself and avoid last-minute stress during the real exam.</p>

                    </div>
                </div>
                <div class="el-blgs-comments ">
                    <div class="el-blgs-cmts-img">
                        💡
                    </div>
                    <div class="el-blgs-cmts">
                        <div class="el-blgs-cmt-name">
                            <h5>Simulate Real Exam Conditions</h5>

                        </div>
                        <p class="el-para">Create an exam-like environment from the comfort of your own device.<br>

                            Train your mind to focus under test conditions.</p>

                    </div>
                </div>
                <div class="el-blgs-comments ">
                    <div class="el-blgs-cmts-img">
                        🧭
                    </div>
                    <div class="el-blgs-cmts">
                        <div class="el-blgs-cmt-name">
                            <h5>Develop a Smart Test-Taking Strategy</h5>

                        </div>
                        <p class="el-para">Understand the pattern and weightage of different sections.<br>

                            Use this insight to plan your approach and maximize your score.
                        </p>

                    </div>
                </div>

            </div>

        </div>
    </form>
</div>